import React, { useState, useMemo, useEffect } from "react";
import { observer } from "mobx-react-lite";

import {
  ViewSewerObject,
  ViewSewerObjectFromAssignedProject,
} from "../../../services/authorization/Permissions";
import PageLayout from "../../_layout/PageLayout";
import SewerObjectsMap from "../../../components/map/SewerObjectsMap";
import { ActionsSection } from "../../../components/data-components/sections/DataSections";
import { CurrentStructureStorageModel } from "../../../services/sewer-object/CurrentStructureStorage";
import { StructureMenuItemsModel } from "./StructureMenuItems";
import { SewerObjectsMapStorageModel } from "../../../services/sewer-object/SewerObjectsMapStorage";
import useUrlParams from "../../../services/url/UrlParamsService";
import { api } from "../../../services/api/ApiService";
import { useHistory } from "react-router-dom";
import { EntityTypeFromPath } from "../../../services/breadcrumbs/EntityTypeFromPathModel";
import useRouteService from "../../../services/route-service/RouteService";
import { breadcrumbsStorage } from "../../../services/breadcrumbs/BreadcrumbsStorage";

export default observer(function ViewStructureOnMap() {
  const history = useHistory();
  const urlParamsService = useUrlParams();
  const { isUserOnProjects } = useRouteService();
  const structureId = useMemo(() => urlParamsService.getStructureId()!, [urlParamsService]);

  const [currentStructureStorage] = useState(() =>
    CurrentStructureStorageModel.create(
      {
        structureId: structureId,
        parentEntityFromPath: {
          id: urlParamsService.getSewerObjectParentId()!,
          type: isUserOnProjects() ? EntityTypeFromPath.Project : EntityTypeFromPath.Job,
        },
      },
      { api }
    )
  );

  const [structureMenuItems] = useState(() =>
    StructureMenuItemsModel.create(
      {
        structureId: structureId,
        parentIdFromPath: currentStructureStorage.parentEntityFromPath.id,
      },
      { api }
    )
  );

  const [sewerObjectsMapStorage] = useState(() =>
    SewerObjectsMapStorageModel.create(
      { inputSewerObjects: [structureId], autoLoad: false },
      { api }
    )
  );

  const menuItems = {
    staticItems: structureMenuItems.getStaticMenuItems(),
  };

  useEffect(() => {
    async function loadBreadcrumbsData() {
      breadcrumbsStorage.setEntityNames([
        {
          entity: currentStructureStorage.parentEntityFromPath.type,
          name: await currentStructureStorage.getParentEntityName(
            currentStructureStorage.currentStructure.project.name
          ),
        },
        {
          entity: EntityTypeFromPath.SewerObject,
          name: currentStructureStorage.currentStructure.name,
        },
      ]);

      breadcrumbsStorage.updateBreadcrumbs(history.location.pathname);
    }

    loadBreadcrumbsData();
  }, [currentStructureStorage, currentStructureStorage.currentStructure, history.location.pathname]);

  return (
    <PageLayout
      accessWithOneOfThePermissions={[ViewSewerObject, ViewSewerObjectFromAssignedProject]}
      titleKey="ViewStructureOnMap.title"
      titleContext={{ structureName: currentStructureStorage.currentStructure.name }}
      id="view-structure-on-map"
      menuItems={menuItems}
      isLoading={currentStructureStorage.isLoading || sewerObjectsMapStorage.isDataLoading}
    >
      {structureId && !currentStructureStorage.currentStructure.hasGeometry && (
        <ActionsSection noBorder warningKey="ViewStructureOnMap.noGeometryWarning" />
      )}
      {structureId && currentStructureStorage.currentStructure.hasGeometry && (
        <div className="map-page-container">
          <SewerObjectsMap sewerObjectsMapStorage={sewerObjectsMapStorage} fullPage />
        </div>
      )}
    </PageLayout>
  );
});
